export default "__VITE_ASSET__DWj1bV2U__"